<template>
  <div class="w-full">
    <div class="w-full mb-6 md:mb-12 border-l border-black pl-6 pt-6 pb-0">
      <div class="w-full">
        <h4 class="text-lg md:text-3xl">Office</h4>
        <p class="text-sm">
          16 Rooke Street
          <br />
          Devonport TAS 7310
          <br />
          Phone: 03 6424 7736
        </p>
        <p class="text-sm leading-5 pt-1">
          Business Hours: Monday – Friday 9am – 5pm
        </p>
      </div>
    </div>
    <div class="w-full mb-1 md:mb-4">
      <CustomInputFour
        v-model="submitDetails.name"
        type="text"
        name=""
        placeholder="Name"
        errorMsg=""
        :error="submitErrors.name"
        @input="updateFormErrors()"
      />
    </div>
    <div class="w-full mb-1 md:mb-4">
      <CustomInputFour
        v-model="submitDetails.email"
        type="email"
        name=""
        placeholder="Email"
        errorMsg=""
        :error="submitErrors.email"
        @input="updateFormErrors()"
      />
    </div>
    <div class="w-full mb-1 md:mb-4">
      <CustomInputFour
        v-model="submitDetails.phone"
        type="text"
        name=""
        placeholder="Phone"
        errorMsg=""
        :error="submitErrors.phone"
        @input="updateFormErrors()"
      />
    </div>
    <div class="w-full mb-1 md:mb-4">
      <CustomTextareaFour
        v-model="submitDetails.message"
        type="text"
        name=""
        placeholder="Message (Time / Budget / Site Location)"
        errorMsg=""
        rows="5"
        :error="submitErrors.message"
        @input="updateFormErrors()"
      />
    </div>
    <div class="w-full mt-2">
      <CustomButtonFive @onClick="submitForm" dark>Submit</CustomButtonFive>
    </div>

    <div class="hidden md:block w-full mt-12">
      <h4>Tailored. Collaborative. Dynamic.</h4>
    </div>
  </div>
</template>

<script>
import CustomInputFour from '@/components/elements/CustomInputFour.vue'
import CustomTextareaFour from '@/components/elements/CustomTextareaFour.vue'
import CustomButtonFive from '@/components/elements/CustomButtonFive.vue'

export default {
  name: 'ContactForm',
  components: {
    CustomInputFour,
    CustomTextareaFour,
    CustomButtonFive
  },
  props: {
  },
  data () {
    return {
      formHasErrors: false,
      submittedOnce: false,
      submitDetails: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      submitErrors: {
        name: false,
        email: false,
        phone: false,
        message: false
      }
    }
  },
  computed: {
    nameInError () {
      var toReturn = false
      if (!this.submittedOnce) toReturn = false
      else if (this.submitDetails.name) toReturn = false
      else toReturn = true
      return toReturn
    }
  },
  methods: {
    updateFormErrors () {
      this.formHasErrors = false
      if (this.submitDetails.name) this.submitErrors.name = false
      else {
        this.submitErrors.name = true
        this.formHasErrors = true
      }

      if (this.submitDetails.phone) this.submitErrors.phone = false
      else {
        this.submitErrors.phone = true
        this.formHasErrors = true
      }

      if (this.submitDetails.email) this.submitErrors.email = false
      else {
        this.submitErrors.email = true
        this.formHasErrors = true
      }

      if (this.submitDetails.message) this.submitErrors.message = false
      else {
        this.submitErrors.message = true
        this.formHasErrors = true
      }
    },
    submitForm () {
      this.submittedOnce = true
      this.updateFormErrors()
      if (!this.formHasErrors) this.$emit('onSubmit', this.submitDetails)
    }
  }
}

</script>

<style lang="scss">

</style>
